import { API } from '../config/api';
import { DataService } from '../config/dataService/dataService';
import { ImportDataService } from '../config/dataService/importDataService';

export class FinalCustomersService {
  static IDENTIFICATION_ALREADY_EXISTS = 'IDENTIFICATION_ALREADY_EXISTS';

  static async getAll({ search = '', page = 1 } = {}) {
    const { data } = await DataService.get(API.finalCustomers.root, { search, page });
    return {
      finalCustomers: data.finalCustomers,
      total: data.total,
      page: data.page,
      pageSize: data.pageSize,
    };
  }

  static async getFinalCustomers({ page, search }) {
    const params = {
      page,
      search,
    };
    const { data } = await DataService.get(API.finalCustomers.root, params);
    return {
      finalCustomers: data.finalCustomers,
      total: data.total,
      pageSize: data.pageSize,
    };
  }

  static async getById(finalCustomerId) {
    const { data } = await DataService.get(API.finalCustomers.root + finalCustomerId);
    return data.finalCustomer;
  }

  static async createFinalCustomer(customerData) {
    const body = FinalCustomersService.getCustomerDataToSend(customerData);
    const { data } = await DataService.post(API.finalCustomers.root, body);
    return data.finalCustomer;
  }

  static async updateFinalCustomer(customerId, customerData) {
    const body = FinalCustomersService.getCustomerDataToSend(customerData);
    const { data } = await DataService.patch(API.finalCustomers.root + customerId, body);
    return data.finalCustomer;
  }

  static async removeFinalCustomer(finalCustomerId) {
    const { data } = await DataService.delete(API.finalCustomers.root + finalCustomerId);
    return data.finalCustomer;
  }

  static async importFinalCustomers(file) {
    const { data } = await ImportDataService.sendFile(API.importData.finalCustomers, file);
    return {
      updated: data.updated,
      new: data.new,
      errors: data.errors,
      errorsCount: data.errorsCount,
    };
  }

  static async getByDocument(identificationType, identification) {
    const params = {
      identificationType,
      identification,
    };
    const { data } = await DataService.get(`${API.finalCustomers.root}${API.finalCustomers.identification}`, params);
    return data.finalCustomer;
  }

  static getCustomerDataToSend(customerData) {
    return {
      nationalityCountry: customerData.nationalityCountry,
      identificationType: customerData.identificationType,
      identification: customerData.identification,
      name: customerData.name,
      firstName: customerData.firstName,
      secondName: customerData.secondName,
      lastName: customerData.lastName,
      secondLastName: customerData.secondLastName,
      birthDate: customerData.birthDate,
      biologicalSex: customerData.biologicalSex,
      sexualOrientation: customerData.sexualOrientation,
      genderIdentity: customerData.genderIdentity,
      bloodType: customerData.bloodType,
      residenceState: customerData.residenceState,
      residenceCity: customerData.residenceCity,
      address: customerData.address,
      addressExtra: customerData.addressExtra,
      markerCoords: customerData.markerCoords,
      healthInsuranceCode: customerData.healthInsuranceCode,
      regime: customerData.regime,
      email: customerData.email,
      idColor: customerData.idColor,
      phone: customerData.phone,
      mobilePhone: customerData.mobilePhone,
      mobilePhoneIndicative: customerData.mobilePhoneIndicative,
      optionalMobilePhone: customerData.optionalMobilePhone,
      tags: customerData.tags,
      scholarlyLevel: customerData.scholarlyLevel,
      extendedForm: customerData.extendedForm,
      condition: customerData.condition,
    };
  }

  static async getOverviewFinalCustomer(idFinalCustomer) {
    const params = {
      idFinalCustomer,
    };
    const { data } = await DataService.get(`${API.patientOverview.root}`, params);
    return {
      data,
    };
  }

  static async getFinalCustomerSettings() {
    const { data } = await DataService.get(API.finalCustomers.settings);
    return {
      finalCustomersSettings: data?.finalCustomerSettings,
    };
  }

  static async updateFinalCustomerSettings(accountId, dataSettings) {
    const { data } = await DataService.patch(API.finalCustomers.settings, {
      accountId,
      ...dataSettings,
    });
    return {
      finalCustomersSettings: data,
    };
  }
}
